import {useAMap} from "../mixins/amap"
import {useStatusHandler} from "../mixins/status_handler"

export default class extends ApplicationController {
    static targets = ["lnglatOutput", "status"]
    static values = {path: Array, status: String, exportUrl: String}

    initialize() {
        this.map = null
        this.marker = null
    }

    connect() {
        useAMap(this)
        useStatusHandler(this)

        this.initMap()
        this.initVideo()
    }

    export(event) {
        window.location = this.exportUrlValue
        event.preventDefault()
    }

    initMap() {
        this.loadMap("map", 20, (map) => {
            this.map = map

            this.makePathOnMap(this.map, this.pathValue)
            this.makeCirclesOnMap(this.map, this.pathValue, this.onCircleClick)

            this.marker = this.makeMarkerOnMap(this.map, this.firstLocationPoint)
        })
    }

    initVideo() {
        this.player = new Plyr('#player')
        this.player.on("timeupdate", this.onPlayerTimeUpdate)
    }

    get firstLocationPoint() {
        return this.pathValue[0]
    }

    get beginTime() {
        return this.firstLocationPoint.t
    }

    onCircleClick = (data) => {
        let circle = data.target
        let time = circle.getExtData()
        this.player.currentTime = time - this.beginTime
    }

    onPlayerTimeUpdate = () => {
        if (this.map && this.marker) {
            let sec = Math.trunc(this.player.currentTime)
            let location = this.getLocationAt(sec)

            if (location) {
                this.marker.setPosition(location)
                this.map.setCenter(location)

                this.lnglatOutputTarget.innerHTML = `${location[0]}, ${location[1]}`
            }
        }
    }

    getLocationAt(sec) {
        let beginTime = this.beginTime
        for (let location of this.pathValue) {
            if ((location.t - beginTime) === sec) {
                return [location.x, location.y]
            }
        }

        return null
    }
}